import { render, staticRenderFns } from "./Entregador.vue?vue&type=template&id=0dc5ab72"
import script from "./Entregador.vue?vue&type=script&lang=js"
export * from "./Entregador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports